<div id="otp" fxLayout="column" linPerfectScrollbar>
  <div id="otp-form-wrapper" fxLayout="column" fxLayoutAlign="center center">
    <div id="otp-form">
      <div class="logo">
        <img [src]="(platformSettings$ | async)?.logoUrl" />
      </div>
      <div class="title">{{ 'OTP.TITLE_TEXT' | translate }} ({{ 'OTP.PHONE_DESCRIPTION' | translate }} {{ phoneNumber }})</div>
      <div class="description">{{ 'OTP.DESCRIPTION' | translate }}</div>
      @if (formError) {
      <div class="form-error">{{ formError }}</div>
      }
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="form-row">
          <mat-form-field class="form-input auth">
            <input
              formControlName="verificationCode"
              matInput="matInput"
              placeholder="{{ 'OTP.PLACEHOLDER' | translate }}"
              autocomplete="off"
            />
            <mat-error>
              <lin-form-field-error></lin-form-field-error>
            </mat-error>
          </mat-form-field>
        </div>
        <div class="form-footer" fxLayout="column" fxLayoutAlign="center center">
          <lin-form-submit-button [isLoading]="isSubmitting"> {{ 'BUTTONS.SUBMIT' | translate }} </lin-form-submit-button>
        </div>
      </form>
    </div>
  </div>
</div>
